import { Chip, ChipProps } from "@mui/material";
import * as React from "react";

interface IProps {
    maxWidth?: string | number;
    minWidth?: string | number;
}

export type MprcChipProps = IProps & ChipProps;

export const MprcChip: React.FC<MprcChipProps> = (props) => {
    const { maxWidth = "350px", minWidth, size = "small", sx, ...rest } = props;

    return (
        <Chip {...rest} size={size} sx={{ ...sx, maxWidth, minWidth, "&.MuiAutocomplet-tag": { maxWidth } }} />
    );
};
